export const translateRequisitesPath = 'affiliate-program.blocks.requisites-and-contract';
